import { render, staticRenderFns } from "./detailDetail.vue?vue&type=template&id=28802136&scoped=true"
import script from "./detailDetail.vue?vue&type=script&lang=js"
export * from "./detailDetail.vue?vue&type=script&lang=js"
import style0 from "./detailDetail.vue?vue&type=style&index=0&id=28802136&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28802136",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28802136')) {
      api.createRecord('28802136', component.options)
    } else {
      api.reload('28802136', component.options)
    }
    module.hot.accept("./detailDetail.vue?vue&type=template&id=28802136&scoped=true", function () {
      api.rerender('28802136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/lending/detailDetail.vue"
export default component.exports